export const frFR = {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  name: "Vous avez d'autres questions ?",
  description:
    "Notre service client est disponible du lundi au vendredi de 8 h à 22 h, le samedi de 9 h à 18 h. Contactez-nous pour toute question concernant votre assurance.",
  mainEntity: {
    "@type": "Organization",
    name: "Lassie AB",
    url: "https://lassie.fr",
    logo: "https://lassie.fr/images/logo-with-name.svg",
    address: {
      "@type": "PostalAddress",
      streetAddress: "9 rue des Colonnes",
      addressLocality: "Paris",
      postalCode: "75002",
      addressCountry: "FR",
    },
    contactPoint: [
      {
        "@type": "ContactPoint",
        contactType: "Service client",
        email: "contact@lassie.fr",
        availableLanguage: "French",
        areaServed: "FR",
        hoursAvailable: [
          {
            "@type": "OpeningHoursSpecification",
            closes: "22:00:00",
            dayOfWeek: "https://schema.org/Monday",
            opens: "08:00:00",
          },
          {
            "@type": "OpeningHoursSpecification",
            closes: "22:00:00",
            dayOfWeek: "https://schema.org/Tuesday",
            opens: "08:00:00",
          },
          {
            "@type": "OpeningHoursSpecification",
            closes: "22:00:00",
            dayOfWeek: "https://schema.org/Wednesday",
            opens: "08:00:00",
          },
          {
            "@type": "OpeningHoursSpecification",
            closes: "22:00:00",
            dayOfWeek: "https://schema.org/Thursday",
            opens: "08:00:00",
          },
          {
            "@type": "OpeningHoursSpecification",
            closes: "22:00:00",
            dayOfWeek: "https://schema.org/Friday",
            opens: "08:00:00",
          },
          {
            "@type": "OpeningHoursSpecification",
            closes: "18:00:00",
            dayOfWeek: "https://schema.org/Saturday",
            opens: "09:00:00",
          },
        ],
      },
      {
        "@type": "ContactPoint",
        contactType: "Service sinistres",
        email: "sinistres@lassie.fr",
        availableLanguage: "French",
        areaServed: "FR",
      },
      {
        "@type": "ContactPoint",
        contactType: "Réclamations générales",
        email: "reclamations@lassie.fr",
        availableLanguage: "French",
        areaServed: "FR",
      },
      {
        "@type": "ContactPoint",
        contactType: "Réclamations sinistres",
        email: "reclamationssinistres@lassie.fr",
        availableLanguage: "French",
        areaServed: "FR",
      },
    ],
  },
};
